import { useCallback, useEffect, useState } from "react";
import Button from "../../ui/Button";
import { AddIcon } from "../../utils/icon.utils";
import RemoveAdditionalCost from "./RemoveAdditionalCost";
import { useGetAllCarInfoByCarInfoTypeSlug } from "../../utils/carInfo.utils";
import MoneyReceiptSection from "./MoneyReceiptSection";
import FormSectionTitle from "../../components/styled/FormSectionTitle";
import { arrayMap } from "../../utils/array.utils";

export default function CarAdditionalCost({
  watch,
  control,
  errors,
  unregister,
  setValue,
  others
}) {
  const { data: additionalCostTypes, loading } =
    useGetAllCarInfoByCarInfoTypeSlug("customer-services");
  const additionalCost = others?.defaultValues?.car?.additionalCost;
  const additionalCostLength = additionalCost?.length;
  const haveAdditionalCost = !!(additionalCostLength > 0);

  const [fields, setFields] = useState([]);
  const [count, setCount] = useState(haveAdditionalCost ? additionalCostLength : 0);

  // function generate field
  const generateFields = useCallback(
    (index) => {
      return [
        {
          label: `${index + 1}. Name`,
          name: `car.additionalCost.${index}.name`,
          type: "select",
          placeholder: "Select a name",
          col: { md: 4 },
          options: additionalCostTypes,
          index
        },
        {
          label: "Cost",
          name: `car.additionalCost.${index}.cost`,
          type: "number",
          placeholder: "Cost",
          col: { md: 3 },
          index
        },
        {
          label: "Remarks",
          name: `car.additionalCost.${index}.remarks`,
          type: "text",
          placeholder: "Remarks",
          col: { md: 3 },
          index
        },
        {
          name: `RemoveAdditionalCost-${index}`,
          type: "custom",
          customComponent: RemoveAdditionalCost,
          col: { md: 2 },
          others: { count: index, setFields },
          index
        }
      ];
    },
    [additionalCostTypes]
  );

  // if have default value then call only one time generateFields
  useEffect(() => {
    function handleDefaultValue() {
      const initFields =
        (
          arrayMap(additionalCost, (item, index) => generateFields(index, setFields)) || []
        ).flat() || undefined;

      if (initFields) {
        setFields(initFields);
      }
    }

    handleDefaultValue();
  }, [additionalCost, generateFields, haveAdditionalCost]);

  // handle add new additional cost
  const handleAdd = (index) => {
    const field = generateFields(index);
    setCount(count + 1);
    setFields((prev) => [...prev, ...field]);
  };

  const isLoading = loading;

  return (
    <MoneyReceiptSection
      setValue={setValue}
      fields={fields}
      control={control}
      watch={watch}
      errors={errors}
      loading={isLoading}
      unregister={unregister}>
      {/* render additional cost title and add button */}
      <div className="row align-items-center mb-3">
        <div className="col-6">
          <FormSectionTitle>Additional Cost</FormSectionTitle>
          <p>{fields.length === 0 ? "To add an additional cost, click the 'Add' button." : ""}</p>
        </div>
        <div className="col-6">
          <div className="text-end">
            <Button onClick={() => handleAdd(count)} name="Add" icon={AddIcon} />
          </div>
        </div>
      </div>
    </MoneyReceiptSection>
  );
}
